import React from 'react';
import { Card, Table, Button } from '../ui';
import { Calendar, DollarSign, TrendingUp, Activity, AlertTriangle, Info } from 'lucide-react';
export function LiquidityMonitoringView() {
  const liquidityData = [{
    participant: 'Royal Bank of Canada',
    settlement: '$45.00M',
    working: '$12.50M',
    techCounter: '$500,000',
    netPosition: '$57.00M',
    available: '$0.00M',
    odLimit: 'Max: $10.0M'
  }, {
    participant: 'Scotiabank',
    settlement: '$38.00M',
    working: '$8.20M',
    techCounter: '$120,000',
    netPosition: '$46.08M',
    available: '$0.00M',
    odLimit: 'Max: $8.0M'
  }, {
    participant: 'Bank of The Bahamas',
    settlement: '$12.00M',
    working: '$4.50M',
    techCounter: '$0',
    netPosition: '$16.50M',
    available: '$0.00M',
    odLimit: 'Max: $5.0M'
  }, {
    participant: 'Commonwealth Bank',
    settlement: '$22.00M',
    working: '$6.70M',
    techCounter: '$250,000',
    netPosition: '$28.45M',
    available: '$0.00M',
    odLimit: 'Max: $6.0M'
  }];
  return <div className="space-y-8" data-id="element-358">
      {/* Header */}
      <div className="flex justify-between items-start" data-id="element-359">
        <div data-id="element-360">
          <h2 className="text-3xl font-serif font-bold text-bank-navy" data-id="element-361">
            Liquidity & Real-Time Monitoring
          </h2>
          <p className="text-slate-500 mt-2 text-lg" data-id="element-362">
            The "Vault" View: Monitor system-wide liquidity and participant
            positions.
          </p>
        </div>
        <Button variant="primary" className="bg-bank-navy hover:bg-bank-navy-light shadow-sm" data-id="element-363">
          <Calendar className="mr-2 h-4 w-4" data-id="element-364" />
          Schedule Adjustment
        </Button>
      </div>

      {/* Metric Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-365">
        {/* Card 1 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm relative overflow-hidden" data-id="element-366">
          <div className="flex justify-between items-start" data-id="element-367">
            <div data-id="element-368">
              <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-369">
                Total Net Position
              </p>
              <p className="text-3xl font-bold text-bank-navy" data-id="element-370">$148.5M</p>
            </div>
            <div className="h-10 w-10 rounded-full bg-slate-50 flex items-center justify-center" data-id="element-371">
              <DollarSign className="h-5 w-5 text-slate-400" data-id="element-372" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm font-medium text-green-600" data-id="element-373">
            <TrendingUp className="h-4 w-4 mr-1" data-id="element-374" />
            <span data-id="element-375">+2.4% vs yesterday</span>
          </div>
        </div>

        {/* Card 2 - Technical Counter */}
        <div className="bg-white rounded-xl border border-orange-200 p-6 shadow-sm relative overflow-hidden ring-1 ring-orange-100" data-id="element-376">
          <div className="flex justify-between items-start" data-id="element-377">
            <div data-id="element-378">
              <div className="flex items-center space-x-1 mb-1" data-id="element-379">
                <p className="text-xs font-bold text-slate-500 tracking-wider uppercase" data-id="element-380">
                  Technical Counter
                </p>
                <Info className="h-3 w-3 text-slate-400" data-id="element-381" />
              </div>
              <p className="text-3xl font-bold text-orange-500" data-id="element-382">$870K</p>
            </div>
            <div className="h-10 w-10 rounded-full bg-orange-50 flex items-center justify-center" data-id="element-383">
              <Activity className="h-5 w-5 text-orange-500" data-id="element-384" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm font-medium text-orange-600" data-id="element-385">
            <AlertTriangle className="h-4 w-4 mr-1" data-id="element-386" />
            <span data-id="element-387">Incomplete outgoing</span>
          </div>
        </div>

        {/* Card 3 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm relative overflow-hidden" data-id="element-388">
          <div className="flex justify-between items-start" data-id="element-389">
            <div data-id="element-390">
              <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-391">
                Available Liquidity
              </p>
              <p className="text-3xl font-bold text-bank-navy" data-id="element-392">$147.6M</p>
            </div>
            <div className="h-10 w-10 rounded-full bg-green-50 flex items-center justify-center" data-id="element-393">
              <DollarSign className="h-5 w-5 text-green-600" data-id="element-394" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm text-slate-500" data-id="element-395">
            <span data-id="element-396">After counter deduction</span>
          </div>
        </div>

        {/* Card 4 */}
        <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm relative overflow-hidden" data-id="element-397">
          <div className="flex justify-between items-start" data-id="element-398">
            <div data-id="element-399">
              <p className="text-xs font-bold text-slate-500 tracking-wider uppercase mb-1" data-id="element-400">
                System Status
              </p>
              <p className="text-3xl font-bold text-green-600" data-id="element-401">Healthy</p>
            </div>
            <div className="h-10 w-10 rounded-full bg-green-50 flex items-center justify-center" data-id="element-402">
              <TrendingUp className="h-5 w-5 text-green-600" data-id="element-403" />
            </div>
          </div>
          <div className="mt-4 flex items-center text-sm text-slate-500" data-id="element-404">
            <span data-id="element-405">All participants operational</span>
          </div>
        </div>
      </div>

      {/* Formula Box */}
      <div className="bg-blue-50/50 border border-blue-100 rounded-lg p-5 flex items-start space-x-4" data-id="element-406">
        <Info className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-407" />
        <div className="space-y-2" data-id="element-408">
          <h4 className="font-bold text-bank-navy" data-id="element-409">
            Available Balance Calculation
          </h4>
          <div className="inline-block bg-white border border-blue-100 rounded px-3 py-1.5 font-mono text-sm text-slate-700 shadow-sm" data-id="element-410">
            Available Balance = (Settlement Account + Working Account) -
            Technical Counter - Net Position
          </div>
          <p className="text-sm text-slate-600 max-w-4xl" data-id="element-411">
            The Technical Counter represents the sum of all incomplete outgoing
            transactions. This amount is temporarily locked until transactions
            complete or timeout.
          </p>
        </div>
      </div>

      {/* Participant Table */}
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-412">
        <div className="px-6 py-5 border-b border-slate-100" data-id="element-413">
          <h3 className="text-xl font-serif font-bold text-bank-navy" data-id="element-414">
            Participant Liquidity Positions
          </h3>
          <p className="text-slate-500 mt-1 text-sm" data-id="element-415">
            Real-time view of settlement and working accounts across the
            network. Hover over Available Balance for calculation details.
          </p>
        </div>
        <Table data={liquidityData} columns={[{
        header: 'PARTICIPANT',
        accessorKey: 'participant' as const,
        className: 'font-medium text-slate-900 text-xs tracking-wider'
      }, {
        header: 'SETTLEMENT ACCT',
        accessorKey: 'settlement' as const,
        className: 'font-mono text-slate-600 text-xs tracking-wider'
      }, {
        header: 'WORKING ACCT',
        accessorKey: 'working' as const,
        className: 'font-mono text-slate-600 text-xs tracking-wider'
      }, {
        header: 'TECH. COUNTER',
        accessorKey: 'techCounter' as const,
        className: 'font-mono text-xs tracking-wider',
        cell: (item: any) => <span className={item.techCounter === '$0' ? 'text-slate-400' : 'text-orange-500 font-bold'} data-id="element-417">
                  {item.techCounter}
                </span>
      }, {
        header: 'NET POSITION',
        accessorKey: 'netPosition' as const,
        className: 'font-mono text-slate-600 text-xs tracking-wider'
      }, {
        header: 'AVAILABLE BALANCE',
        accessorKey: 'available' as const,
        className: 'font-mono font-bold text-bank-navy text-xs tracking-wider'
      }, {
        header: 'OD LIMIT',
        accessorKey: 'odLimit' as const,
        className: 'text-slate-400 text-xs'
      }]} data-id="element-416" />
      </div>
    </div>;
}